import axios from 'axios';
import { hasFeature } from '@/utils/features';

/** Estado de la caja del usuario actual (mismo criterio que POS / mostrador). */
export async function fetchEstadoCajaActual() {
    if (!hasFeature('caja')) {
        return { requerida: false, abierta: true, cajaId: null, caja: null, resumen: null };
    }
    try {
        const { data } = await axios.get('/cajas/actual');
        if (data && data.code === 'MODULO_NO_HABILITADO') {
            return { requerida: false, abierta: true, cajaId: null, caja: null, resumen: null };
        }
        return {
            requerida: true,
            abierta: !!data.abierta,
            cajaId: data.caja && data.caja.caja_id != null ? data.caja.caja_id : null,
            caja: data.caja || null,
            resumen: data.resumen || null,
        };
    } catch (e) {
        const d = e.response && e.response.data;
        if (
            e.response &&
            (e.response.status === 503 ||
                (e.response.status === 403 && d && d.code === 'MODULO_NO_HABILITADO'))
        ) {
            return { requerida: false, abierta: true, cajaId: null, caja: null, resumen: null };
        }
        throw e;
    }
}

export function mensajeBannerCaja(estado, opts = {}) {
    const compact = opts && opts.compact === true;
    if (!estado.requerida) return '';
    const cajaLabel =
        estado.cajaId != null && String(estado.cajaId).startsWith('local_')
            ? 'local'
            : estado.cajaId;
    if (estado.abierta) {
        if (compact) {
            return cajaLabel != null ? `Caja #${cajaLabel}` : 'Caja abierta';
        }
        return `Caja abierta (#${cajaLabel}). Los pedidos de mostrador se registran en este turno.`;
    }
    if (compact) return 'Abrí la caja para cobrar';
    return 'Tenés que abrir la caja antes de tomar pedidos o cobrar en el POS.';
}
